import { useLayoutEffect, useState, type ReactNode } from "react";

// TODO: add empty state
export const DropdownRenderV2 = ({
  children,
  syncWidthId,
}: {
  children?: ReactNode;
  syncWidthId?: string;
}) => {
  const [labelWidth, setLabelWidth] = useState<number | undefined>();

  useLayoutEffect(() => {
    const triggerElement = syncWidthId
      ? document.getElementById(syncWidthId)
      : undefined;

    if (triggerElement) {
      setLabelWidth(triggerElement.offsetWidth);
    }
  }, [syncWidthId]);

  return (
    <div
      style={{
        width: syncWidthId && labelWidth ? labelWidth : "fit-content",
      }}
      className="bg-white border border-gray-v2-200 p-1 rounded-lg shadow-lg"
    >
      {children}
    </div>
  );
};
